import { AudienceInterestTermsAndConditions } from './AudienceInterestTermsAndConditions'

interface AudienceInterestTextProps {
  title: string
  description: string
  isTermsAndConditions?: boolean
  isStreaming?: boolean
}

export const AudienceInterestText = ({
  title,
  description,
  isTermsAndConditions = false,
  isStreaming = false,
}: AudienceInterestTextProps) => {
  return (
    <div className="z-30 flex flex-col gap-3">
      <span className="text-2xl font-bold text-white">{title}</span>
      <div className="flex gap-2">
        <span className="text-sm text-gray-400 ">{description}</span>
      </div>
      {isTermsAndConditions ? <AudienceInterestTermsAndConditions isStreaming={isStreaming} /> : null}
    </div>
  )
}
